module.exports = __webpack_public_path__ + "img/live-default-header.a7f34b68.png";